import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authApi } from '../api';
import { Button, Input } from '../components/ui';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState<'login' | 'reset'>('login');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(phone, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const sendCode = async () => {
    setMsg('');
    setError('');
    try {
      const res: any = await authApi.sendCode(phone, 'reset');
      setMsg(res.devCode ? `开发模式验证码：${res.devCode}` : '验证码已发送');
    } catch (err: any) {
      setError(err.message);
    }
  };

  const resetSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authApi.resetPassword({ phone, code, newPassword });
      setMsg('密码已重置，请用新密码登录');
      setMode('login');
      setCode('');
      setNewPassword('');
      setPassword('');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm bg-surface border border-border rounded-sm p-6 shadow-sm">
        <h1 className="text-lg font-semibold text-ink mb-1">樾快工作台</h1>
        <p className="text-sm text-muted mb-5">{mode === 'login' ? '登录你的账套' : '找回密码'}</p>

        {mode === 'login' ? (
          <form onSubmit={submit} className="space-y-3">
            <Input label="手机号" value={phone} onChange={(e: any) => setPhone(e.target.value)} placeholder="13800000000" />
            <Input label="密码" type="password" value={password} onChange={(e: any) => setPassword(e.target.value)} placeholder="至少 6 位" />
            {error && <div className="text-sm text-red-600">{error}</div>}
            <Button className="w-full justify-center" disabled={loading}>{loading ? '登录中…' : '登录'}</Button>
          </form>
        ) : (
          <form onSubmit={resetSubmit} className="space-y-3">
            <Input label="手机号" value={phone} onChange={(e: any) => setPhone(e.target.value)} placeholder="13800000000" />
            <div className="flex gap-2">
              <Input label="验证码" value={code} onChange={(e: any) => setCode(e.target.value)} placeholder="4-6 位" />
              <div className="flex items-end"><Button type="button" variant="weak" onClick={sendCode}>获取验证码</Button></div>
            </div>
            <Input label="新密码" type="password" value={newPassword} onChange={(e: any) => setNewPassword(e.target.value)} placeholder="至少 6 位" />
            {msg && <div className="text-sm text-green-600">{msg}</div>}
            {error && <div className="text-sm text-red-600">{error}</div>}
            <Button className="w-full justify-center" disabled={loading}>{loading ? '重置中…' : '重置密码'}</Button>
          </form>
        )}

        <div className="mt-4 text-sm text-muted text-center space-y-1">
          {mode === 'login' ? (
            <div className="text-xs">账号由主账号统一开通，忘记密码请联系管理员</div>
          ) : (
            <div><button type="button" className="text-primary hover:underline" onClick={() => { setMode('login'); setError(''); setMsg(''); }}>返回登录</button></div>
          )}
        </div>
      </div>
    </div>
  );
}
